import { Badge } from "antd";
import { Toast } from "antd-mobile";
import copy from "copy-to-clipboard";
import { MessageCircleMoreIcon, SettingsIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import { imgList } from "./img-list";
import "./index.css";

export default function MyCenter({
  userInfo,
  companyData,
  loginmsg,
  pledgeStatus,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const inviteType = localStorage.getItem("inviteType");
  const c2ctxStatus = localStorage.getItem("c2ctxStatus");
  const c2cczStatus = localStorage.getItem("c2cczStatus");
  const lan = localStorage.getItem("i18n");
  const handleCopy = (value) => {
    if (copy(value)) {
      Toast.show({ content: translate(getText("成功")) });
    }
  };
  const types = ["未認證", "審核中", "已認證", "審核拒絕"];

  return (
    <div className="min-h-screen bg-neutral-900 text-black pb-16">
      {/* 顶部模块 - 用户头像和信息 */}
      <div className="relative bg-gradient-primary p-5 pt-10 pb-8 rounded-b-2xl shadow-lg">
        <div className="flex justify-between items-center mb-5">
          <div
            className="w-10 h-10 flex items-center justify-center"
            onClick={() => navigate("/noice")}
          >
            <MessageCircleMoreIcon />
          </div>
          <div
            className="w-10 h-10 flex items-center justify-center"
            onClick={() => navigate("/setting")}
          >
            <SettingsIcon className="text-2xl" />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div className="relative">
            <div className="w-20 h-20 rounded-full border-2 border-white/50 bg-neutral-800 overflow-hidden shadow-md">
              <img
                src={imageConfig.baseImageUrl + companyData?.companyLogo}
                className="w-full h-full object-cover"
                alt="Profile"
              />
            </div>
          </div>
          <div className="flex-1">
            <div className="text-xl font-bold mb-1">
              {`${userInfo?.username}`.replace("undefined", "").split("@")[0]}
            </div>
            <div className="text-sm text-white/70 mb-1 flex items-center">
              <span>ID: </span>
              <span className="mr-1">{userInfo?.userCode}</span>
              {/* <span 
                onClick={() => handleCopy(userInfo?.userCode)}
                className="text-primary cursor-pointer ml-1"
              >
                <MobileOutlined />
              </span> */}
            </div>
            <div className="text-sm text-white/70">
              {translate(getText("信用分"))}:{" "}
              <span className="text-primary-light">{userInfo?.jifen}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 菜单列表 */}
      <div className="px-4 pt-4 space-y-3 text-white">
        {/* 认证服务区域 */}
        <div className="space-y-3">
          {/* 身份认证 */}
          <div
            className={`flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition ${
              userInfo?.rzstatus === 2 ? "opacity-80" : ""
            }`}
            onClick={() => {
              if (userInfo?.rzstatus === 2) return;
              navigate("/idcard");
            }}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-34"]}
                  className="w-full h-full"
                  alt="ID"
                />
              </div>
              <span className="font-medium">
                {translate(getText("身份認證"))}
              </span>
            </div>
            <div className="flex items-center">
              <span
                className={`mr-2 ${
                  userInfo?.rzstatus === 2 ? "text-primary" : "text-primary/70"
                }`}
              >
                {translate(getText(types[userInfo?.rzstatus]))}
              </span>
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* 高级认证 */}
          {
            <div
              className={`flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl transition ${
                userInfo?.advanceRzstatus === 2 && userInfo?.cardsc
                  ? "opacity-80"
                  : "active:bg-neutral-700"
              }`}
              onClick={() => {
                if (userInfo?.advanceRzstatus === 2) return;
                navigate("/gjidcard");
              }}
            >
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <img
                    src={imgList["mycenter-34"]}
                    className="w-full h-full"
                    alt="Advanced ID"
                  />
                </div>
                <span className="font-medium">
                  {translate(getText("高级認證"))}
                </span>
              </div>
              <div className="flex items-center">
                <span
                  className={`mr-2 ${
                    userInfo?.advanceRzstatus === 2
                      ? "text-primary"
                      : "text-primary/70"
                  }`}
                >
                  {userInfo?.advanceRzstatus === 2
                    ? translate(getText(types[userInfo?.advanceRzstatus]))
                    : translate(getText(types[0]))}
                </span>
                <i className="fa fa-chevron-right text-neutral-500"></i>
              </div>
            </div>
          }

          {/* 借款 */}
          {pledgeStatus === 1 && (
            <div
              className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
              onClick={() => navigate("/borrowmoney")}
            >
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <img
                    src={imgList["mycenter-96"]}
                    className="w-full h-full"
                    alt="Borrow"
                  />
                </div>
                <span className="font-medium">
                  {translate(getText("借款"))}
                </span>
              </div>
              <div className="flex items-center">
                <i className="fa fa-chevron-right text-neutral-500"></i>
              </div>
            </div>
          )}
        </div>

        {/* 交易记录区域 */}
        <div className="space-y-3">
          {/* 交易记录 */}
          <div
            className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
            onClick={() => navigate("/jyjl")}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-56"]}
                  className="w-full h-full"
                  alt="Transactions"
                />
              </div>
              <span className="font-medium">
                {translate(getText("交易記錄"))}
              </span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* C2C充值记录 */}
          {c2cczStatus === "1" && (
            <div
              className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
              onClick={() => navigate("/c2ccklist")}
            >
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <img
                    src={imgList["mycenter-56"]}
                    className="w-full h-full"
                    alt="C2C Deposits"
                  />
                </div>
                <span className="font-medium">
                  {translate(getText("C2C充值記錄"))}
                </span>
              </div>
              <div className="flex items-center">
                <i className="fa fa-chevron-right text-neutral-500"></i>
              </div>
            </div>
          )}

          {/* C2C提现记录 */}
          {c2ctxStatus === "1" && (
            <div
              className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
              onClick={() => navigate("/c2ctklist")}
            >
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <img
                    src={imgList["mycenter-56"]}
                    className="w-full h-full"
                    alt="C2C Withdrawals"
                  />
                </div>
                <span className="font-medium">
                  {translate(getText("C2C提现記錄"))}
                </span>
              </div>
              <div className="flex items-center">
                <i className="fa fa-chevron-right text-neutral-500"></i>
              </div>
            </div>
          )}
        </div>

        {/* 账户服务区域 */}
        <div className="space-y-3">
          {/* 安全中心 */}
          <div
            className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
            onClick={() => navigate("/securitycenter")}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-45"]}
                  className="w-full h-full"
                  alt="Security"
                />
              </div>
              <span className="font-medium">
                {translate(getText("安全中心"))}
              </span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* 留言列表 */}
          <div
            className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
            onClick={() => navigate("/noice")}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-116"]}
                  className="w-full h-full"
                  alt="Messages"
                />
              </div>
              <span className="font-medium relative">
                {translate(getText("留言列表"))}
                <Badge
                  count={loginmsg?.noticeCount ? loginmsg?.noticeCount : 0}
                  offset={[8, -3]}
                  className="ml-1"
                  size="small"
                />
              </span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* 在线客服 */}
          <div
            className={`flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl transition ${
              userInfo?.black === 1 ? "opacity-80" : "active:bg-neutral-700"
            }`}
            onClick={() => {
              if (userInfo?.black === 1) return;
              navigate("/chatcenter");
            }}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 bg-[#3d29d1] rounded-full flex items-center justify-center text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 32 32"
                  className="text-white"
                >
                  <path
                    fill="white"
                    d="M29.715 12.955h1.52v6.09h-1.52Zm-19.81 0h1.52v-1.53h1.53v-1.52h6.09v1.52h1.53v-1.52h4.57v1.52h1.52v12.19h1.53v-3.04h1.52v-1.53h-1.52v-6.09h1.52v-1.53h-1.52v-6.09h-1.53v1.52h-1.52v-1.52h-3.05v-1.53h-10.67v1.53h-1.52v1.52h-1.52v3.05h-1.53v-4.57h-1.52v4.57h-1.52v1.52h6.09z"
                  />
                  <path
                    fill="white"
                    d="M25.145 23.615h1.52v1.53h-1.52Zm0-19.81h1.52v1.53h-1.52Zm-1.53 16.77h1.53v1.52h-1.53Zm0-4.58h1.53v3.05h-1.53Zm0-13.71h1.53v1.52h-1.53Zm-12.19 22.86V28.2h-3.04v1.52h-3.05v1.52h24.38v-1.52h-3.05V28.2h-3.05v-1.53h1.53v-1.52Zm10.67 4.57h-6.09V28.2h-3.05v-1.53H22.1Zm-3.05-7.62h4.57v1.52h-4.57Zm-1.52-1.52h1.52v1.52h-1.52Zm-1.52-4.58h1.52v3.05h-1.52Zm0-4.57h3.04v1.53h-3.04Zm-4.58 1.53h1.53v6.09h-1.53ZM9.905.765h13.71v1.52H9.905Zm0 22.85h1.52v1.53h-1.52Zm0-4.57h1.52v1.53h-1.52Zm-6.09 1.53v1.52h4.57v1.52h1.52v-3.04zm4.57-18.29h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.53h-1.53Zm-1.52 9.15h1.52v1.52h-1.52Zm-1.52 1.52h1.52v3.05h-1.52Zm-1.53 4.57h1.53v1.53h-1.53Zm0-7.62h1.53v1.53h-1.53Zm-1.52 1.53h1.52v6.09H.765Z"
                  />
                </svg>
              </div>
              <span className="font-medium relative">
                {translate(getText("在線客服"))}
                <Badge
                  count={loginmsg?.userCount}
                  offset={[8, -3]}
                  className="ml-1"
                  size="small"
                />
              </span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* 帮助中心 */}
          <div
            className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
            onClick={() => navigate("/helplist")}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-126"]}
                  className="w-full h-full"
                  alt="Help"
                />
              </div>
              <span className="font-medium">
                {translate(getText("幫助中心"))}
              </span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>

          {/* 设置 */}
          <div
            className="flex items-center justify-between px-5 py-4 bg-neutral-800 rounded-xl active:bg-neutral-700 transition"
            onClick={() => navigate("/setting")}
          >
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <img
                  src={imgList["mycenter-135"]}
                  className="w-full h-full"
                  alt="Settings"
                />
              </div>
              <span className="font-medium">{translate(getText("设置"))}</span>
            </div>
            <div className="flex items-center">
              <i className="fa fa-chevron-right text-neutral-500"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
